import { render, staticRenderFns } from "./VideoRecommendComm.vue?vue&type=template&id=05fe1afe&scoped=true&"
import script from "./VideoRecommendComm.vue?vue&type=script&lang=js&"
export * from "./VideoRecommendComm.vue?vue&type=script&lang=js&"
import style0 from "./VideoRecommendComm.vue?vue&type=style&index=0&id=05fe1afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe1afe",
  null
  
)

export default component.exports